import type { Status } from '../api'

/**
 * Linear's status ring, mapped onto the reel loop.
 *
 * Dotted for an idea (not started), half for scripted, a filled centre once
 * it is filmed, solid with a play mark once the reel exists, a check once it
 * is out. Shape carries the meaning so the row can stay monochrome and leave
 * colour to the series dot.
 */
export function StatusIcon({ status, size = 16 }: { status: Status; size?: number }) {
  return (
    <svg
      className="status-icon"
      data-status={status}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      aria-hidden="true"
      focusable="false"
    >
      {glyph(status)}
    </svg>
  )
}

function glyph(status: Status) {
  const ring = <circle cx="8" cy="8" r="6.25" fill="none" stroke="currentColor" strokeWidth="1.5" />
  switch (status) {
    case 'idea':
      return (
        <circle
          cx="8"
          cy="8"
          r="6.25"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeDasharray="1.6 2.3"
          strokeLinecap="round"
        />
      )
    case 'scripted':
      return (
        <>
          {ring}
          <path d="M8 4.25a3.75 3.75 0 0 1 0 7.5z" fill="currentColor" />
        </>
      )
    case 'filmed':
      return (
        <>
          {ring}
          <circle cx="8" cy="8" r="3.75" fill="currentColor" />
        </>
      )
    case 'edited':
      return (
        <>
          <circle cx="8" cy="8" r="7" fill="currentColor" />
          <path d="M6.6 5.4v5.2L10.8 8z" fill="var(--bg)" />
        </>
      )
    case 'published':
      return (
        <>
          <circle cx="8" cy="8" r="7" fill="currentColor" />
          <path
            d="M5.1 8.2l2 2 3.8-4"
            fill="none"
            stroke="var(--bg)"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'killed':
      return (
        <>
          {ring}
          <path d="M6 6l4 4M10 6l-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </>
      )
  }
}
